import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

import { rerunTask } from "./api";
import {
  handleTaskActionError,
  invalidateTaskViews,
} from "./invalidateTaskViews";

// Ручной повторный запуск задачи с UI. На успех инвалидируем те
// же кэши, что и cancel: task, task-events, tasks и queue — статус, лог
// переходов, список и активная задача очереди могут все измениться
// (rerun вернул задачу в QUEUED → backend в фоне активирует
// простаивающую очередь через dispatch_next_in_queue). Инвалидация по
// смысловому префиксу матчит запись любого org-скоупа (см.
// `src/query/scope.ts`).
export function useRerunTask(
  taskId: string,
): ReturnType<typeof useMutation<void, Error, void>> {
  const queryClient = useQueryClient();
  const { t } = useTranslation();
  return useMutation<void, Error, void>({
    mutationFn: () => rerunTask(taskId),
    onSuccess: () => {
      invalidateTaskViews(queryClient, taskId);
    },
    onError: (error) => {
      handleTaskActionError(queryClient, taskId, error, t);
    },
  });
}
